import CommonEnvs from './common/env';
import { prodUrls } from './constants/prod-constant';

const createApiConfig = (baseUrl: string) => ({
  base_url: baseUrl,
  useCustomHeaders: true,
});

export default {
  ...CommonEnvs,
  API: {
    'auth-api': createApiConfig(prodUrls.authServiceUrl),
    'provider-api': createApiConfig(prodUrls.providerServiceUrl),
    'appointment-api': createApiConfig(prodUrls.appointmentServiceUrl),
    'macros-api': createApiConfig(prodUrls.macrosServiceUrl),
    'ehr-api': createApiConfig(prodUrls.ehrServiceUrl),
    'transcript-api': createApiConfig(prodUrls.transcriptServiceUrl),
    'graphql-api': createApiConfig(prodUrls.graphqlApiUrl),
    'text-expander-api': createApiConfig(prodUrls.textExpanderServiceUrl),
    'gwp-api': createApiConfig(prodUrls.gwpServiceUrl),
    'signup-api': { base_url: prodUrls.signupServiceUrl },
    'nrt-api': { base_url: prodUrls.nrtServerUrl },
    'user-management-api': { base_url: prodUrls.userManagementServiceUrl },
    'sso-api': { base_url: prodUrls.ssoServiceUrl },
  },
  URL: {
    'signup-url': 'https://g-go.augmedix.com/signup',
  },
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyABDot6h5H1ESMPKbDx2nvVX8Y2SzRD5qY',
    authDomain: 'gcp-prod-env.firebaseapp.com',
    projectId: 'gcp-prod-env',
    storageBucket: 'gcp-prod-env.firebasestorage.app',
    messagingSenderId: '735255733114',
    appId: '1:735255733114:web:ec120ad45fae1895dbacc3',
    measurementId: 'G-DV6K2JLR89',
  },
};
